import { render, staticRenderFns } from "./Wallet.vue?vue&type=template&id=125d08f0&scoped=true"
import script from "./Wallet.vue?vue&type=script&lang=js"
export * from "./Wallet.vue?vue&type=script&lang=js"
import style0 from "./Wallet.vue?vue&type=style&index=0&id=125d08f0&prod&scoped=true&lang=css"
import style1 from "./Wallet.vue?vue&type=style&index=1&id=125d08f0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "125d08f0",
  null
  
)

export default component.exports